module.exports = __webpack_public_path__ + "static/media/cizik-school-of-nursing-logo-uth.a7997cc6.svg";